import desktopImage from './similar-vehicles-desktop.png';
import mobileImage from './similar-vehicles-mobile.png';

export { desktopImage, mobileImage };
